<template>
<ItpBox
  direction="column"
  alignItems="stretch"
  v-if="loaded"
>
  <ItpBox
    alignItems="center"
    class="pb-2"
  >
    <strong>
      {{ 'Invoice Lines'|pgettext('Invoice') }}
    </strong>
    <strong
      class="ml-1"
      v-if="invoiceLines.length"
    >
      ({{ invoiceLines.length }})
    </strong>
    <ItpButton
      :icon="$config.uploadIcon"
      size="sm"
      :text="'Upload...'|pgettext('Invoice|InvoiceLines')"
      :tooltip="'Upload invoice lines from file.'|pgettext('Invoice|InvoiceLines|Tooltip')"
      class="ml-3"
      v-if="!invoice.isReadOnly"
      @click.prevent.stop="evh_1889980785424776_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      :icon="$config.deleteIcon"
      size="sm"
      :text="'Delete'|pgettext('Invoice|InvoiceLines|Command')"
      :tooltip="'Remove the selected lines.'|pgettext('Invoice|InvoiceLines|Tooltip')"
      :disabled="!hasSelectedInvoiceLines"
      class="ml-3"
      v-if="!invoice.isReadOnly"
      @click.prevent.stop="evh_4892266742011185_clickPreventStop($event, {})"
    >
    </ItpButton>
  </ItpBox>
  <ItpDataTable
    rowKey="id"
    tableId="invoiceLines"
    rowDetailsMode="alwaysVisible"
    :rowHeader="b_5962862420439144_rowHeader"
    :paging="b_5962862420439144_paging"
    :sortable="b_5962862420439144_sortable"
    :editable="!invoice.isReadOnly"
    :value="invoiceLines"
    :groups="invoiceLineGroups"
    groupKeyField="line_group_id"
    variant="details"
    row-selection
    columnHeaderStyle="cellheaderWhenEditing"
    cellClass="font-weight-bold"
    footer-totals
    :rowTemplate="b_5962862420439144_rowTemplate"
    :messages="b_5962862420439144_messages"
    :globs="{searchDataSource, messages}"
    :columns="b_5962862420439144_columns"
    class="h-100"
    @save-completed="evh_5962862420439144_saveCompleted($event, {})"
    @save="evh_5962862420439144_save($event, {})"
    @createProduct="evh_5962862420439144_createProduct($event, {})"
    @delete="evh_5962862420439144_delete($event, {})"
    @product:selected="evh_5962862420439144_productSelected($event, {})"
    @quantity:change="evh_5962862420439144_quantityChange($event, {})"
    @price:change="evh_5962862420439144_priceChange($event, {})"
    @discount:change="evh_5962862420439144_discountChange($event, {})"
    @net_amount:change="evh_5962862420439144_netAmountChange($event, {})"
    @amount:change="evh_5962862420439144_amountChange($event, {})"
    @tax_code:change="evh_5962862420439144_taxCodeChange($event, {})"
    @rental_or_property:selected="evh_5962862420439144_rentalOrPropertySelected($event, {})"
    @selectedRowsChanged="evh_5962862420439144_selectedRowsChanged($event, {})"
  >
    <template
      v-slot:rowGroupHeader="{ group, rows }"
    >
      <ItpBox>
        <UcInvoiceLineGroup
          :invoice="invoice"
          :group="group"
          @reload="evh_7789867021953041_reload($event, {group, rows})"
        >
        </UcInvoiceLineGroup>
      </ItpBox>
    </template>
    <template
      v-slot:afterLastRow="{ table }"
    >
      <ItpBox>
        <ItpLink
          :icon="$config.addIcon"
          size="sm"
          :text="'Add group...'|pgettext('InvoiceLineGroup')"
          class="ml-3"
          @click.prevent.stop="evh_309515315410323_clickPreventStop($event, {table})"
        >
        </ItpLink>
      </ItpBox>
    </template>
    <template
      v-slot:rowDetails="{ row }"
    >
      <div
        class="container-fluid  px-lg-1"
      >
        <ItpRow
          class="no-gutters"
        >
          <ItpCol
            w="2"
          >
            <ItpText
              pre
              :text="row.notes"
              v-if="row.notes && !row.isEditing"
            >
            </ItpText>
            <ItpFormTextarea
              rows="3"
              name="notes"
              :placeholder="'Notes'|gettext"
              v-model="row.notes"
              :disabled="!row.isEditing"
              class="mb-2"
              v-if="row.isEditing"
            >
            </ItpFormTextarea>
            <ItpFormSelect2
              name="reference_invoice_id"
              :placeholder="'Reference invoice'|pgettext('InvoiceLine')"
              v-model="row.reference_invoice_id"
              :initialOptions="row.reference_invoice ? [row.reference_invoice] : []"
              :dataSource="b_1270943406604881_dataSource"
              valueField="id"
              clearable
              optionTemplate="<UcSuggestInvoiceOption :option=option></UcSuggestInvoiceOption>"
              use-option-template-for-selected-option
              v-if="row.isEditing"
            >
            </ItpFormSelect2>
          </ItpCol>
          <ItpCol
            w="10"
          >
            <ItpBox
              v-if="!row.isNew && (row.isEditing || row.meter_accounting) && invoiceRentalNumber"
            >
              <ItpLink
                :icon="$config.addIcon"
                size="sm"
                :text="'Select readings...'|pgettext('InvoiceLines')"
                @click.prevent.stop="evh_880971572885910_clickPreventStop($event, {row})"
              >
              </ItpLink>
            </ItpBox>
            <ItpDataTable
              tableId="invoiceLineMeters"
              variant="basic"
              compact
              :paging="b_1803307708030275_paging"
              :sortable="b_1803307708030275_sortable"
              :rowHeader="b_1803307708030275_rowHeader"
              use-index-as-row-key
              :fillEmptyRowSpace="b_1803307708030275_fillEmptyRowSpace"
              :value="row.meter_accounting ? [row.meter_accounting] : []"
              :editable="!invoice.isReadOnly && !row.locked"
              :noCreateRow="!!row.meter_accounting"
              :globs="{ units, searchDataSource }"
              :messages="b_1803307708030275_messages"
              :rowTemplate="{
    invoice_id: invoice.id,
    invoice_line_id: row.id,
    from_date: null,
    from_amount: null,
    from_unit: null,
    to_date: null,
    to_amount: null,
    to_unit: null,
    billing_multiplier: 1
  }"
              :columns="b_1803307708030275_columns"
              class="bg-transparent datatable-basic mb-1"
              v-if="!row.isNew && row.isEditing || row.meter_accounting"
              @save="evh_1803307708030275_save($event, {row})"
              @save-completed="evh_1803307708030275_saveCompleted($event, {row})"
              @delete="evh_1803307708030275_delete($event, {row})"
              @delete-completed="evh_1803307708030275_deleteCompleted($event, {row})"
            >
            </ItpDataTable>
            <ItpDataTable
              tableId="invoiceLineAccounting"
              variant="basic"
              compact
              :paging="b_7700024326226090_paging"
              :sortable="b_7700024326226090_sortable"
              :rowHeader="b_7700024326226090_rowHeader"
              :fillEmptyRowSpace="b_7700024326226090_fillEmptyRowSpace"
              :value="row.accountings.data"
              :editable="!invoice.isReadOnly && !row.locked"
              :rowTemplate="schemaDefaults('CreateInvoiceLineAccounting', {
    invoice_id: invoice.id,
    invoice_line_id: row.id,
  })"
              :globs="{ searchDataSource }"
              :messages="b_7700024326226090_messages"
              :columns="b_7700024326226090_columns"
              class="bg-transparent datatable-basic mb-1"
              v-if="row.isEditing && !row.isNew || (row.accountings && row.accountings.data && row.accountings.data.length)"
              @save="evh_7700024326226090_save($event, {row})"
              @delete="evh_7700024326226090_delete($event, {row})"
              @save-completed="evh_7700024326226090_saveCompleted($event, {row})"
              @delete-completed="evh_7700024326226090_deleteCompleted($event, {row})"
            >
            </ItpDataTable>
            <ItpBox
              class="mb-3"
            >
              <DIV
                class="ml-auto"
                v-if="hasQuantityMismatch(row)"
              >
                <ItpIcon
                  icon="material-symbols:warning-rounded"
                  class="text-warning"
                >
                </ItpIcon>
                <ItpText
                  strong
                  :text="'Quantity mismatch.'|pgettext('invoiceLineAccounting')"
                >
                </ItpText>
              </DIV>
            </ItpBox>
          </ItpCol>
        </ItpRow>
      </div>
    </template>
  </ItpDataTable>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceLines extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  onProductSelected(...args: any[]) {
    let [row, product] = args;

    this.invoiceLineHelper.onProductSelected(row, product);
    row.setFocus('quantity')
  }

  hasQuantityMismatch(...args: any[]) {
    const row = args[0]
    return row.accountings
      && row.accountings.data
      && row.accountings.data.length
      && _.sumBy(row.accountings.data, p => p.quantity) != row.quantity
  }

  getInvoiceLineEditorIsDisabled(...args: any[]) {
    const [row] = args;
    return !row.tax_code
  }

  onRentalOrPropertySelected(...args: any[]) {
    let [row, selection] = args;


    if (!selection) {
      row.rental = null;
      row.property = null
      return;
    }

    if (_.isObject(selection) && selection.object == 'rental') {
      row.rental = selection;
      row.property = null
      return;
    }

    if (_.isObject(selection) && ['property', 'property_unit'].indexOf(selection.object) > -1) {
      row.rental = null;
      row.property = selection;
      return;
    }
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    required: true,
    type: Object,
  })
  currency!: object;

  @Watch('currency')
  onCurrency(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("currency")
  }

  @Prop({
    type: Number,
  })
  defaultDiscount!: number;

  @Watch('defaultDiscount')
  onDefault_discount(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("defaultDiscount")
  }

  @Prop({
    type: String,
  })
  defaultTaxCode!: string;

  @Watch('defaultTaxCode')
  onDefault_tax_code(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("defaultTaxCode")
  }

  @Prop({
    required: true,
    type: Object,
  })
  formContext!: object;

  @Watch('formContext')
  onForm_context(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formContext")
  }

  expenseTypes!: any;

  async $$load_expenseTypes() {
    return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'expense-type' } })
  }

  taxCodes!: any;

  async $$load_taxCodes() {
    return this.$app.repo.get('list_tax_code')
  }

  currencies!: any;

  async $$load_currencies() {
    return this.$app.repo.get('list_currency')
  }

  units!: any;

  async $$load_units() {
    return this.$app.repo.get('list_unit')
  }

  displayAddInvoiceLine!: any;
  messages!: any;
  invoiceLineHelper!: any;

  async $$load_invoiceLineHelper() {
    return new this.$app.helpers.InvoiceLineHelper(this.invoice, this.$data.currencies, this.$data.taxCodes)
  }

  ux!: any;
  b_5962862420439144_rowHeader!: any;
  b_5962862420439144_paging!: any;
  b_5962862420439144_sortable!: any;
  b_5962862420439144_rowTemplate!: any;

  async $$load_b_5962862420439144_rowTemplate() {
    return {
      description: null,
      discount: this.defaultDiscount || 0,
      notes: null,
    }
  }

  b_5962862420439144_messages!: any;
  b_5962862420439144_columns!: any;

  async $$load_b_5962862420439144_columns() {
    return [{
      name: "product",
      header: this.$fn.gettext("Product"),
      width: "250px",
      required: true,
      textAlign: "left",
      editor: {
        name: "template",
        value: "<ItpSelect2\n\
  class=\"w-100\"\n\
  v-model=\"currentValue\"\n\
  bindObject\n\
  valueField=\"id\"\n\
  textField=\"name\"\n\
  required\n\
  :placeholder=\"messages.msgSearchProduct\"\n\
  :options=\"globs.searchDataSource('suggest_product', {invoice_line_products: 'include'})\"\n\
  :autofocus=autofocus\n\
  :form=\"formId\"\n\
  :inputId=\"col.field\"\n\
  :size=\"col.size\"\n\
  :state=\"validationState\"\n\
  :disabled=\"isDisabled\"\n\
  :tabindex=\"col.tabindex\"\n\
  taggable\n\
  @optionSelected=\"col.emit('product:selected', {col, row, ...$event})\"\n\
  @change=\"onChange($event)\"\n\
>\n\
  <template #search=\"{attributes, events}\">\n\
    <input\n\
      class=\"vs__search\"\n\
      v-bind=\"attributes\"\n\
      v-on=\"events\"\n\
    />\n\
  </template>\n\
\n\
  <template #option=\"option\">\n\
    <UcSuggestProductOption :option=\"option\" v-if=\"option.object=='product'\">\n\
    </UcSuggestProductOption>\n\
    <span v-else>{{ option.name }}</span>\n\
  </template>\n\
\n\
  <template #selected-option=\"option\">\n\
    <UcSuggestProductOption :option=\"option\" v-if=\"option.object=='product'\">\n\
    </UcSuggestProductOption>\n\
    <span v-else>{{ option.name }}</span>\n\
  </template>\n\
\n\
  <template #list-footer>\n\
    <hr />\n\
    <ItpButton\n\
      class=\"ml-2\"\n\
      size=sm\n\
      variant=light\n\
      @click=\"col.emitCellEvent('createProduct', row)\">\n\
      {{ messages.msgCreateProduct }}\n\
    </ItpButton>\n\
  </template>\n\
\n\
  <template #footer>\n\
    <b-form-input\n\
      class=\"mt-1\"\n\
      type=text\n\
      v-model=row.description\n\
      id=\"description\"\n\
      name=\"description\"\n\
      autocomplete=\"off\"\n\
      :form=\"formId\"\n\
      :size=col.size\n\
      :disabled=\"isDisabled\"\n\
      :placeholder=\"globs.messages.invoiceLineDescriptionPlaceholder\"\n\
      @change=\"onFieldChange('description', row.description)\"\n\
    ></b-form-input>\n\
  </template>\n\
</ItpSelect2>\n\
",
      }
      ,
      formatter: {
        name: "template",
        value: "<div class=\"text-truncate\" :title=\"row.description\">\n\
  <b-link v-if=\"row.product\" :to=\"{\n\
    name: 'app.product',\n\
    params: { id: row.product.id }\n\
  }\">{{ row.description }}</b-link>\n\
  <span v-if=\"!row.product\">\n\
    {{ row.description }}\n\
  </span>\n\
</div>\n\
",
      }
      ,
    }
      ,
    {
      name: "advance",
      header: this.$fn.pgettext("InvoiceLine|ColHeader", "Adv."),
      headerTooltip: this.$fn.pgettext("invoiceLine|ColHeader|Tooltip", "Advance"),
      headerTextAlign: "center",
      width: "25px",
      type: "checkbox",
      editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
    }
      ,
    {
      name: "intermediated_service",
      header: this.$fn.pgettext("AbbrIntermediatedService", "IMS"),
      headerTooltip: this.$fn.gettext("Intermediated Service"),
      headerTextAlign: "center",
      width: "25px",
      type: "checkbox",
      editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
    }
      ,
    {
      name: "quantity",
      type: "number",
      maxAllowedDecimals: this.isIncomingInvoice ? null : this.currency.quantity_digits,
      default: 0,
      header: this.$fn.pgettext("Quantity Abbr", "Qty"),
      headerTooltip: this.$fn.gettext("Quantity"),
      headerTextAlign: "right",
      width: "60px",
      textAlign: "right",
      required: true,
      editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
    }
      ,
    {
      name: "unit",
      header: this.$fn.pgettext("Unit Abbr", "Unit"),
      headerTooltip: this.$fn.gettext("Unit"),
      width: "70px",
      textAlign: "center",
      headerTextAlign: "center",
      required: true,
      editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
    }
      ,
    {
      name: "price",
      type: "number",
      maxAllowedDecimals: this.isIncomingInvoice ? null : this.currency.price_digits,
      default: 0,
      header: this.$fn.gettext("Price"),
      width: "70px",
      textAlign: "right",
      headerTextAlign: "right",
      required: true,
      editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
      footerTotals: rows => _.meanBy(rows, p => p.quantity * p.price),
    }
      ,
    {
      name: "discount",
      type: "number",
      maxAllowedDecimals: this.isIncomingInvoice ? null : this.currency.digits,
      default: this.defaultDiscount || 0,
      header: this.$fn.pgettext("AbbrDiscount", "Disc"),
      headerTooltip: this.$fn.gettext("Discount"),
      noFooterTotals: true,
      width: "50px",
      textAlign: "right",
      headerTextAlign: "right",
      required: true,
      editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
    }
      ,
    {
      name: "net_amount",
      type: "number",
      maxAllowedDecimals: this.currency.digits,
      default: 0,
      header: this.$fn.gettext("Net"),
      width: "95px",
      textAlign: "right",
      headerTextAlign: "right",
      required: true,
      editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
    }
      ,
    {
      name: "amount",
      type: "number",
      maxAllowedDecimals: this.currency.digits,
      default: 0,
      header: this.$fn.gettext("Amount"),
      width: "95px",
      textAlign: "right",
      headerTextAlign: "right",
      required: true,
      editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
    }
      ,
    {
      name: "tax_code",
      header: this.$fn.gettext("VAT"),
      headerTooltip: this.$fn.gettext("VAT Code"),
      width: "80px",
      type: "select",
      options: this.taxCodes,
      valueField: "id",
      textField: "id",
      textAlign: "right",
      headerTextAlign: "right",
      editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
    }
      ,
    {
      name: "deductible_vat_amount",
      type: "number",
      disabled: this.isOutgoingInvoice,
      header: this.$fn.gettext("D-VAT"),
      headerTooltip: this.$fn.gettext("Deductible VAT amount"),
      maxAllowedDecimals: this.currency.digits,
      default: 0,
      width: "95px",
      textAlign: "right",
      headerTextAlign: "right",
      editorIsDisabled: this.getInvoiceLineEditorIsDisabled,
    }
      ,
    {
      name: "expense_type",
      type: "select",
      header: this.$fn.pgettext("InvoiceLine|ColHeader", "Expense Type"),
      width: "100px",
      options: this.expenseTypes,
      valueField: "name",
      textField: "name",
    }
      ,
    {
      name: "rental_or_property",
      header: this.$fn.gettext("Cost Center"),
      textAlign: "left",
      width: "100px",
      editor: {
        name: "template",
        value: "<ItpSelect2\n\
  class=\"w-100\"\n\
  v-model=\"currentValue\"\n\
  bindObject\n\
  valueField=\"id\"\n\
  textField=\"name\"\n\
  required\n\
  :placeholder=\"messages.msgSearchCostCenter\"\n\
  :options=\"globs.searchDataSource('suggest_cost_center')\"\n\
  :initialOptions=\"[row.rental || row.property]\"\n\
  :form=\"formId\"\n\
  :inputId=\"col.field\"\n\
  :size=\"col.size\"\n\
  :state=\"validationState\"\n\
  :disabled=\"isDisabled\"\n\
  :tabindex=\"col.tabindex\"\n\
  @optionSelected=\"col.emit('rental_or_property:selected', {col, row, ...$event})\"\n\
  @change=\"onChange($event)\"\n\
>\n\
  <template #search=\"{attributes, events}\">\n\
    <input\n\
      class=\"vs__search\"\n\
      v-bind=\"attributes\"\n\
      v-on=\"events\"\n\
    />\n\
  </template>\n\
\n\
  <template #option=\"option\">\n\
    <UcSuggestRentalOption :option=\"option\" v-if=\"option.object=='rental'\">\n\
    </UcSuggestRentalOption>\n\
    <UcSuggestPropertyOption :option=\"option\" v-if=\"option.object=='property' || option.object == 'property_unit'\">\n\
    </UcSuggestPropertyOption>\n\
  </template>\n\
\n\
  <template #selected-option=\"option\">\n\
    <UcSuggestRentalOption :option=\"option\" v-if=\"option.object=='rental'\">\n\
    </UcSuggestRentalOption>\n\
    <UcSuggestPropertyOption :option=\"option\" v-if=\"option.object=='property' || option.object == 'property_unit'\">\n\
    </UcSuggestPropertyOption>\n\
  </template>\n\
</ItpSelect2>\n\
",
      }
      ,
      formatter: {
        name: "template",
        value: "<div>\n\
  <UcSuggestRentalOption :option=\"row.rental\" v-if=\"row.rental\">\n\
  </UcSuggestRentalOption>\n\
  <UcSuggestPropertyOption :option=\"row.property\" v-if=\"row.property\" display-code>\n\
  </UcSuggestPropertyOption>\n\
</div>\n\
",
      }
      ,
    }
      ,
    ]
  }

  b_1270943406604881_dataSource!: any;

  async $$load_b_1270943406604881_dataSource() {
    return {
      name: "suggest_invoice",
      parameters: {
        invoice_kind: this.invoice.invoice_kind,
        client_id: this.invoice.client.id,
        company_id: this.invoice.company.id,
        exclude_invoice: this.invoice.id,
      }
      ,
    }
  }

  b_1803307708030275_paging!: any;
  b_1803307708030275_sortable!: any;
  b_1803307708030275_rowHeader!: any;
  b_1803307708030275_fillEmptyRowSpace!: any;
  b_1803307708030275_messages!: any;
  b_1803307708030275_columns!: any;

  async $$load_b_1803307708030275_columns() {
    return [{
      name: "meter",
      header: this.$fn.gettext("Meter"),
      width: "160px",
      required: true,
      type: "select2",
      options: this.$fn.searchDataSource('suggest_meter'),
      bindObject: true,
      valueField: "id",
      textField: "serial_number",
      formatter: {
        name: "template",
        value: "<UcMeterMiniCard :item=\"row.meter\" link-style-underline no-strong></UcMeterMiniCard>\n\
",
      }
      ,
    }
      ,
    {
      name: "from",
      header: this.$fn.gettext("Previous reading"),
      width: "160px",
      formatter: {
        name: "template",
        value: "<div>{{ row.from_date|date }} {{ row.from_amount|number }} {{ row.from_unit }}</div>\n\
",
      }
      ,
      editor: {
        name: "template",
        value: "<div class=\"input-group\">\n\
  <ItpFormDatetime\n\
    v-model=\"row.from_date\"\n\
    name=\"from_date\"\n\
    placeholder=\"date\"\n\
    size=\"sm\"\n\
    style=\"min-width:100px;\"\n\
    required\n\
  ></ItpFormDatetime>\n\
\n\
  <ItpFormInput\n\
    type=\"number\"\n\
    name=\"from_amount\"\n\
    v-model=\"row.from_amount\"\n\
    placeholder=\"reading\"\n\
    size=\"sm\"\n\
    style=\"min-width:60px;\"\n\
    required\n\
  ></ItpFormInput>\n\
\n\
  <ItpFormSelect\n\
    v-model=\"row.from_unit\"\n\
    name=\"from_unit\"\n\
    placeholder=\"unit\"\n\
    size=\"sm\"\n\
    :options=\"globs.units\"\n\
    style=\"min-width:60px;\"\n\
    valueField=\"symbol\"\n\
    textField=\"symbol\"\n\
    required\n\
  ></ItpFormSelect>\n\
</div>\n\
",
      }
      ,
    }
      ,
    {
      name: "to",
      header: this.$fn.gettext("Current reading"),
      width: "240px",
      formatter: {
        name: "template",
        value: "<div>{{ row.to_date|date }} {{ row.to_amount|number }} {{ row.to_unit }}</div>\n\
",
      }
      ,
      editor: {
        name: "template",
        value: "<div class=\"input-group\">\n\
  <ItpFormDatetime\n\
    v-model=\"row.to_date\"\n\
    name=\"to_date\"\n\
    placeholder=\"date\"\n\
    size=\"sm\"\n\
    style=\"min-width:100px;\"\n\
    required\n\
  ></ItpFormDatetime>\n\
\n\
  <ItpFormInput\n\
    type=\"number\"\n\
    name=\"to_amount\"\n\
    v-model=\"row.to_amount\"\n\
    placeholder=\"reading\"\n\
    size=\"sm\"\n\
    style=\"min-width:60px;\"\n\
    required\n\
  ></ItpFormInput>\n\
\n\
  <ItpFormSelect\n\
    v-model=\"row.to_unit\"\n\
    name=\"to_unit\"\n\
    placeholder=\"unit\"\n\
    size=\"sm\"\n\
    :options=\"globs.units\"\n\
    style=\"min-width:60px;\"\n\
    valueField=\"symbol\"\n\
    textField=\"symbol\"\n\
    required\n\
  ></ItpFormSelect>\n\
</div>\n\
",
      }
      ,
    }
      ,
    {
      name: "consumption",
      header: this.$fn.gettext("Consumption"),
      readonly: true,
      formatter: {
        name: "template",
        value: "<div>{{ row.consumption_amount|number }} {{ row.consumption_unit }}</div>\n\
",
      }
      ,
    }
      ,
    {
      name: "billing_multiplier",
      header: this.$fn.gettext("Multiplier"),
      default: 1,
      width: "70px",
      type: "number",
      required: true,
    }
      ,
    ]
  }

  b_7700024326226090_paging!: any;
  b_7700024326226090_sortable!: any;
  b_7700024326226090_rowHeader!: any;
  b_7700024326226090_fillEmptyRowSpace!: any;
  b_7700024326226090_messages!: any;
  b_7700024326226090_columns!: any;

  async $$load_b_7700024326226090_columns() {
    return [{
      name: "expense_type",
      type: "select",
      header: this.$fn.gettext("Expense Type"),
      width: "100px",
      options: this.expenseTypes,
      valueField: "name",
      textField: "name",
    }
      ,
    {
      name: "rental",
      type: "select2",
      header: this.$fn.gettext("Rental"),
      width: "100px",
      path: "name",
      bindObject: true,
      textField: "name",
      options: this.$fn.searchDataSource('suggest_rental'),
      useOptionTemplateForSelectedOption: true,
      optionTemplate: "<UcSuggestRentalOption :option=\"option\"></UcSuggestRentalOption>",
    }
      ,
    {
      name: "property",
      type: "select2",
      header: this.$fn.gettext("Property"),
      width: "100px",
      path: "name",
      bindObject: true,
      textField: "name",
      options: this.$fn.searchDataSource('suggest_property'),
      useOptionTemplateForSelectedOption: true,
      optionTemplate: "<UcSuggestPropertyOption :option=\"option\"></UcSuggestPropertyOption>",
    }
      ,
    {
      name: "contractor",
      type: "select2",
      header: this.$fn.gettext("Contractor"),
      width: "100px",
      path: "name",
      bindObject: true,
      textField: "name",
      options: this.$fn.searchDataSource('suggest_company', { 'role': 'partner', 'is-contractor': true }),
    }
      ,
    {
      name: "quantity",
      type: "number",
      header: this.$fn.gettext("Quantity"),
      width: "100px",
    }
      ,
    ]
  }

  dataMembers = ['expenseTypes', 'taxCodes', 'currencies', 'units', 'displayAddInvoiceLine', 'messages', 'invoiceLineHelper', 'ux', 'b_5962862420439144_rowHeader', 'b_5962862420439144_paging', 'b_5962862420439144_sortable', 'b_5962862420439144_rowTemplate', 'b_5962862420439144_messages', 'b_5962862420439144_columns', 'b_1270943406604881_dataSource', 'b_1803307708030275_paging', 'b_1803307708030275_sortable', 'b_1803307708030275_rowHeader', 'b_1803307708030275_fillEmptyRowSpace', 'b_1803307708030275_messages', 'b_1803307708030275_columns', 'b_7700024326226090_paging', 'b_7700024326226090_sortable', 'b_7700024326226090_rowHeader', 'b_7700024326226090_fillEmptyRowSpace', 'b_7700024326226090_messages', 'b_7700024326226090_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        expenseTypes: null,
        taxCodes: null,
        currencies: null,
        units: null,
        displayAddInvoiceLine: null,
        messages: {
          invoiceLineProductSearchPlaceholder: this.$fn.pgettext("InvoiceLines", "Search product/service..."),
          invoiceLineCostCenterSearchPlaceholder: this.$fn.pgettext("invoiceLines", "search..."),
          invoiceLineDescriptionPlaceholder: this.$fn.pgettext("InvoiceLines", "Description"),
        }
        ,
        invoiceLineHelper: null,
        ux: null,
        b_5962862420439144_rowHeader: false,
        b_5962862420439144_paging: false,
        b_5962862420439144_sortable: false,
        b_5962862420439144_rowTemplate: null,
        b_5962862420439144_messages: {
          msgCreateRow: this.$fn.pgettext("InvoiceLines", "Add line"),
          msgCreateProduct: this.$fn.pgettext("InvoiceLines", "Add new product..."),
          msgSearchProduct: this.$fn.pgettext("InvoiceLines", "Search for product/service..."),
          msgSearchCostCenter: this.$fn.pgettext("InvoiceLines", "search..."),
        }
        ,
        b_5962862420439144_columns: null,
        b_1270943406604881_dataSource: null,
        b_1803307708030275_paging: false,
        b_1803307708030275_sortable: false,
        b_1803307708030275_rowHeader: false,
        b_1803307708030275_fillEmptyRowSpace: false,
        b_1803307708030275_messages: {
          msgCreateRow: this.$fn.pgettext("invoiceLines", "New meter row"),
        }
        ,
        b_1803307708030275_columns: null,
        b_7700024326226090_paging: false,
        b_7700024326226090_sortable: false,
        b_7700024326226090_rowHeader: false,
        b_7700024326226090_fillEmptyRowSpace: false,
        b_7700024326226090_messages: {
          msgCreateRow: this.$fn.pgettext("invoiceLines", "New accounting row"),
        }
        ,
        b_7700024326226090_columns: null,
      },
    }
  }

  get invoiceLines() {
    if (this.loaded) {

      return this.invoice.lines.data
    }
    return null;
  }

  get invoiceLineGroups() {
    if (this.loaded) {

      return this.invoice.line_groups.data
    }
    return null;
  }

  get isIncomingInvoice() {
    if (this.loaded) {

      return this.invoice.invoice_kind == 'incoming'
    }
    return null;
  }

  get isOutgoingInvoice() {
    if (this.loaded) {

      return this.invoice.invoice_kind == 'outgoing'
    }
    return null;
  }

  get invoiceRentalNumber() {
    if (this.loaded) {

      return _.chain(this.invoice.references.data).find({ object: 'rental' }).get('name').value()
    }
    return null;
  }

  get hasSelectedInvoiceLines() {
    if (this.loaded) {

      return this.formContext && this.formContext.selectedInvoiceLines && this.formContext.selectedInvoiceLines.length
    }
    return null;
  }

  async act_1889980785424776_showModal_9376_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_1889980785424776_showModal_9376, alias=undefined
    return {
      name: "UploadInvoiceLines",
      props: {
        invoice: this.invoice,
      }
      ,
    }
  }

  async evh_1889980785424776_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1889980785424776_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_4892266742011185_emit_9380_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4892266742011185_emit_9380, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_4892266742011185_request_9378_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4892266742011185_request_9378, alias=deleteSelectedLines
    return {
      operation: "delete_many_invoice_line",
      data: { invoice_id: this.invoice.id, items: _.map(this.formContext.selectedInvoiceLines, p => ({ id: p.id, etag: p.etag })) },
    }
  }

  async evh_4892266742011185_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4892266742011185_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_emit_9382_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5962862420439144_emit_9382, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_5962862420439144_saveCompleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_saveCompleted.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_9384_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_9384, alias=undefined
    this.invoice.id
      ? $event.data.waitFor(this.$fn.crud('invoice_line').upsert({ ...$event.data.row, invoice_id: this.invoice.id }))
      : this.invoiceLines.splice(this.invoiceLines.length - 1, 0, $event.data.row)
  }

  async act_5962862420439144_script_9384_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_9384, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_9384_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_save.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_9388_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_9388, alias=undefined
    this.onProductSelected($event.parent.data.row, $event.data.modalResult.value)
  }

  async act_5962862420439144_script_9388_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_9388, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_9388_getActionArgs_value($event),
    }
  }

  async act_5962862420439144_showModal_9386_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5962862420439144_showModal_9386, alias=undefined
    return {
      name: "CreateProduct",
      props: {
        preventDefaultOnClose: true,
      }
      ,
    }
  }

  async evh_5962862420439144_createProduct(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_createProduct.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_9390_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_9390, alias=undefined
    $event.data.waitFor(this.$fn.crud('invoice_line').delete($event.data.row))
  }

  async act_5962862420439144_script_9390_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_9390, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_9390_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_delete.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_9392_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_9392, alias=undefined
    this.onProductSelected($event.data.row, $event.data.option)
  }

  async act_5962862420439144_script_9392_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_9392, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_9392_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_productSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_productSelected.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_9394_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_9394, alias=undefined
    this.invoiceLineHelper.recalculateLineItem($event.data.row, $event.data.field)
  }

  async act_5962862420439144_script_9394_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_9394, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_9394_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_quantityChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_quantityChange.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_9396_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_9396, alias=undefined
    this.invoiceLineHelper.recalculateLineItem($event.data.row, $event.data.field)
  }

  async act_5962862420439144_script_9396_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_9396, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_9396_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_priceChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_priceChange.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_9398_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_9398, alias=undefined
    this.invoiceLineHelper.recalculateLineItem($event.data.row, $event.data.field)
  }

  async act_5962862420439144_script_9398_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_9398, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_9398_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_discountChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_discountChange.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_9400_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_9400, alias=undefined
    this.invoiceLineHelper.recalculateLineItem($event.data.row, $event.data.field)
  }

  async act_5962862420439144_script_9400_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_9400, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_9400_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_netAmountChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_netAmountChange.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_9402_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_9402, alias=undefined
    this.invoiceLineHelper.recalculateLineItem($event.data.row, $event.data.field)
  }

  async act_5962862420439144_script_9402_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_9402, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_9402_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_amountChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_amountChange.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_9404_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_9404, alias=undefined
    this.invoiceLineHelper.recalculateLineItem($event.data.row, $event.data.field)
  }

  async act_5962862420439144_script_9404_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_9404, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_9404_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_taxCodeChange(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_taxCodeChange.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_script_9406_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_9406, alias=undefined
    this.onRentalOrPropertySelected($event.data.row, $event.data.option)
  }

  async act_5962862420439144_script_9406_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_9406, alias=undefined
    return {
      value: () => this.act_5962862420439144_script_9406_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_rentalOrPropertySelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_rentalOrPropertySelected.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_setData_9408_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5962862420439144_setData_9408, alias=undefined
    return {
      path: "formContext.selectedInvoiceLines",
      value: $event.data.selection,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_5962862420439144_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_7789867021953041_emit_9410_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7789867021953041_emit_9410, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_7789867021953041_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7789867021953041_reload.executeFromDOM(this, event, scope);
  }

  async act_309515315410323_emit_9414_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_309515315410323_emit_9414, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_309515315410323_close_9413_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_309515315410323_close_9413, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_309515315410323_showModal_9412_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_309515315410323_showModal_9412, alias=undefined
    return {
      name: "InvoiceLineGroup",
      props: {
        invoice: this.invoice,
      }
      ,
    }
  }

  async evh_309515315410323_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_309515315410323_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_880971572885910_script_9418_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_880971572885910_script_9418, alias=undefined
    this.$fn.crud('invoice_line')
      .upsert({
        id: $event.scope.row.id,
        etag: $event.scope.row.etag,
        meter_accounting: {
          invoice_id: this.invoice.id,
          invoice_line_id: $event.scope.row.id,
          ...$event.data.modalResult.value,
        }
      }).then(() => this.$emit('reload'))
  }

  async act_880971572885910_script_9418_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_880971572885910_script_9418, alias=undefined
    return {
      value: () => this.act_880971572885910_script_9418_getActionArgs_value($event),
    }
  }

  async evh_880971572885910_close_9417_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_880971572885910_close_9417, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_880971572885910_showModal_9416_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_880971572885910_showModal_9416, alias=undefined
    return {
      name: "InvoiceLineMeterReadingSelector",
      props: {
        rental: this.invoiceRentalNumber,
        multiple: false,
        serviceId: $event.scope.row.product ? $event.scope.row.product.id : null,
      }
      ,
    }
  }

  async evh_880971572885910_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_880971572885910_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_1803307708030275_script_9420_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1803307708030275_script_9420, alias=undefined
    $event.data.waitFor(
      this.$fn.crud('invoice_line')
        .upsert({
          id: $event.scope.row.id,
          etag: $event.scope.row.etag,
          meter_accounting: $event.data.row,
        })
    )
  }

  async act_1803307708030275_script_9420_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1803307708030275_script_9420, alias=undefined
    return {
      value: () => this.act_1803307708030275_script_9420_getActionArgs_value($event),
    }
  }

  async evh_1803307708030275_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1803307708030275_save.executeFromDOM(this, event, scope);
  }

  async act_1803307708030275_emit_9422_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1803307708030275_emit_9422, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_1803307708030275_saveCompleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1803307708030275_saveCompleted.executeFromDOM(this, event, scope);
  }

  async act_1803307708030275_script_9424_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1803307708030275_script_9424, alias=undefined
    $event.data.waitFor(this.$fn.crud('invoice_line_meter_accounting').delete($event.data.row))
  }

  async act_1803307708030275_script_9424_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1803307708030275_script_9424, alias=undefined
    return {
      value: () => this.act_1803307708030275_script_9424_getActionArgs_value($event),
    }
  }

  async evh_1803307708030275_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1803307708030275_delete.executeFromDOM(this, event, scope);
  }

  async act_1803307708030275_emit_9426_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1803307708030275_emit_9426, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_1803307708030275_deleteCompleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1803307708030275_deleteCompleted.executeFromDOM(this, event, scope);
  }

  async act_7700024326226090_script_9428_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7700024326226090_script_9428, alias=undefined
    $event.data.waitFor(
      this.$fn.crud('invoice_line_accounting').upsert($event.data.row)
        .then(p => (this.$emit('reload'), p))
    )
  }

  async act_7700024326226090_script_9428_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7700024326226090_script_9428, alias=undefined
    return {
      value: () => this.act_7700024326226090_script_9428_getActionArgs_value($event),
    }
  }

  async evh_7700024326226090_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7700024326226090_save.executeFromDOM(this, event, scope);
  }

  async act_7700024326226090_script_9430_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7700024326226090_script_9430, alias=undefined
    $event.data.waitFor(this.$fn.crud('invoice_line_accounting').delete($event.data.row))
  }

  async act_7700024326226090_script_9430_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7700024326226090_script_9430, alias=undefined
    return {
      value: () => this.act_7700024326226090_script_9430_getActionArgs_value($event),
    }
  }

  async evh_7700024326226090_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7700024326226090_delete.executeFromDOM(this, event, scope);
  }

  async act_7700024326226090_emit_9432_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7700024326226090_emit_9432, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_7700024326226090_saveCompleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7700024326226090_saveCompleted.executeFromDOM(this, event, scope);
  }

  async act_7700024326226090_emit_9434_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7700024326226090_emit_9434, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_7700024326226090_deleteCompleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7700024326226090_deleteCompleted.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1889980785424776_showModal_9376: actions.ShowModalAction;
    evh_1889980785424776_clickPreventStop_9375: actions.EventHandlerImpl;
    evh_1889980785424776_clickPreventStop: actions.EventHandlerGroup;
    act_4892266742011185_emit_9380: actions.EmitAction;
    evh_4892266742011185_success_9379: actions.EventHandlerImpl;
    act_4892266742011185_request_9378: actions.RequestAction;
    evh_4892266742011185_clickPreventStop_9377: actions.EventHandlerImpl;
    evh_4892266742011185_clickPreventStop: actions.EventHandlerGroup;
    act_5962862420439144_emit_9382: actions.EmitAction;
    evh_5962862420439144_saveCompleted_9381: actions.EventHandlerImpl;
    evh_5962862420439144_saveCompleted: actions.EventHandlerGroup;
    act_5962862420439144_script_9384: actions.ScriptAction;
    evh_5962862420439144_save_9383: actions.EventHandlerImpl;
    evh_5962862420439144_save: actions.EventHandlerGroup;
    act_5962862420439144_script_9388: actions.ScriptAction;
    evh_5962862420439144_close_9387: actions.EventHandlerImpl;
    act_5962862420439144_showModal_9386: actions.ShowModalAction;
    evh_5962862420439144_createProduct_9385: actions.EventHandlerImpl;
    evh_5962862420439144_createProduct: actions.EventHandlerGroup;
    act_5962862420439144_script_9390: actions.ScriptAction;
    evh_5962862420439144_delete_9389: actions.EventHandlerImpl;
    evh_5962862420439144_delete: actions.EventHandlerGroup;
    act_5962862420439144_script_9392: actions.ScriptAction;
    evh_5962862420439144_productSelected_9391: actions.EventHandlerImpl;
    evh_5962862420439144_productSelected: actions.EventHandlerGroup;
    act_5962862420439144_script_9394: actions.ScriptAction;
    evh_5962862420439144_quantityChange_9393: actions.EventHandlerImpl;
    evh_5962862420439144_quantityChange: actions.EventHandlerGroup;
    act_5962862420439144_script_9396: actions.ScriptAction;
    evh_5962862420439144_priceChange_9395: actions.EventHandlerImpl;
    evh_5962862420439144_priceChange: actions.EventHandlerGroup;
    act_5962862420439144_script_9398: actions.ScriptAction;
    evh_5962862420439144_discountChange_9397: actions.EventHandlerImpl;
    evh_5962862420439144_discountChange: actions.EventHandlerGroup;
    act_5962862420439144_script_9400: actions.ScriptAction;
    evh_5962862420439144_netAmountChange_9399: actions.EventHandlerImpl;
    evh_5962862420439144_netAmountChange: actions.EventHandlerGroup;
    act_5962862420439144_script_9402: actions.ScriptAction;
    evh_5962862420439144_amountChange_9401: actions.EventHandlerImpl;
    evh_5962862420439144_amountChange: actions.EventHandlerGroup;
    act_5962862420439144_script_9404: actions.ScriptAction;
    evh_5962862420439144_taxCodeChange_9403: actions.EventHandlerImpl;
    evh_5962862420439144_taxCodeChange: actions.EventHandlerGroup;
    act_5962862420439144_script_9406: actions.ScriptAction;
    evh_5962862420439144_rentalOrPropertySelected_9405: actions.EventHandlerImpl;
    evh_5962862420439144_rentalOrPropertySelected: actions.EventHandlerGroup;
    act_5962862420439144_setData_9408: actions.SetDataAction;
    evh_5962862420439144_selectedRowsChanged_9407: actions.EventHandlerImpl;
    evh_5962862420439144_selectedRowsChanged: actions.EventHandlerGroup;
    act_7789867021953041_emit_9410: actions.EmitAction;
    evh_7789867021953041_reload_9409: actions.EventHandlerImpl;
    evh_7789867021953041_reload: actions.EventHandlerGroup;
    act_309515315410323_emit_9414: actions.EmitAction;
    evh_309515315410323_close_9413: actions.EventHandlerImpl;
    act_309515315410323_showModal_9412: actions.ShowModalAction;
    evh_309515315410323_clickPreventStop_9411: actions.EventHandlerImpl;
    evh_309515315410323_clickPreventStop: actions.EventHandlerGroup;
    act_880971572885910_script_9418: actions.ScriptAction;
    evh_880971572885910_close_9417: actions.EventHandlerImpl;
    act_880971572885910_showModal_9416: actions.ShowModalAction;
    evh_880971572885910_clickPreventStop_9415: actions.EventHandlerImpl;
    evh_880971572885910_clickPreventStop: actions.EventHandlerGroup;
    act_1803307708030275_script_9420: actions.ScriptAction;
    evh_1803307708030275_save_9419: actions.EventHandlerImpl;
    evh_1803307708030275_save: actions.EventHandlerGroup;
    act_1803307708030275_emit_9422: actions.EmitAction;
    evh_1803307708030275_saveCompleted_9421: actions.EventHandlerImpl;
    evh_1803307708030275_saveCompleted: actions.EventHandlerGroup;
    act_1803307708030275_script_9424: actions.ScriptAction;
    evh_1803307708030275_delete_9423: actions.EventHandlerImpl;
    evh_1803307708030275_delete: actions.EventHandlerGroup;
    act_1803307708030275_emit_9426: actions.EmitAction;
    evh_1803307708030275_deleteCompleted_9425: actions.EventHandlerImpl;
    evh_1803307708030275_deleteCompleted: actions.EventHandlerGroup;
    act_7700024326226090_script_9428: actions.ScriptAction;
    evh_7700024326226090_save_9427: actions.EventHandlerImpl;
    evh_7700024326226090_save: actions.EventHandlerGroup;
    act_7700024326226090_script_9430: actions.ScriptAction;
    evh_7700024326226090_delete_9429: actions.EventHandlerImpl;
    evh_7700024326226090_delete: actions.EventHandlerGroup;
    act_7700024326226090_emit_9432: actions.EmitAction;
    evh_7700024326226090_saveCompleted_9431: actions.EventHandlerImpl;
    evh_7700024326226090_saveCompleted: actions.EventHandlerGroup;
    act_7700024326226090_emit_9434: actions.EmitAction;
    evh_7700024326226090_deleteCompleted_9433: actions.EventHandlerImpl;
    evh_7700024326226090_deleteCompleted: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1889980785424776_showModal_9376 = new actions.ShowModalAction(
      {
        actionArgs: this.act_1889980785424776_showModal_9376_getActionArgs,
        events: [],
      }
    );
    const evh_1889980785424776_clickPreventStop_9375 = new actions.EventHandlerImpl(
      {
        action: act_1889980785424776_showModal_9376,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_1889980785424776_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1889980785424776_clickPreventStop_9375],
      }
    );
    const act_4892266742011185_emit_9380 = new actions.EmitAction(
      {
        actionArgs: this.act_4892266742011185_emit_9380_getActionArgs,
        events: [],
      }
    );
    const evh_4892266742011185_success_9379 = new actions.EventHandlerImpl(
      {
        action: act_4892266742011185_emit_9380,
        event: "success",
        displayName: "emit",
      }
    );
    const act_4892266742011185_request_9378 = new actions.RequestAction(
      {
        actionArgs: this.act_4892266742011185_request_9378_getActionArgs,
        displayName: "deleteSelectedLines",
        events: [evh_4892266742011185_success_9379],
      }
    );
    const evh_4892266742011185_clickPreventStop_9377 = new actions.EventHandlerImpl(
      {
        action: act_4892266742011185_request_9378,
        event: "click.prevent.stop",
        displayName: "deleteSelectedLines",
      }
    );
    const evh_4892266742011185_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4892266742011185_clickPreventStop_9377],
      }
    );
    const act_5962862420439144_emit_9382 = new actions.EmitAction(
      {
        actionArgs: this.act_5962862420439144_emit_9382_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_saveCompleted_9381 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_emit_9382,
        event: "save-completed",
        displayName: "emit",
      }
    );
    const evh_5962862420439144_saveCompleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_saveCompleted_9381],
      }
    );
    const act_5962862420439144_script_9384 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_9384_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_save_9383 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_9384,
        event: "save",
        displayName: "script",
      }
    );
    const evh_5962862420439144_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_save_9383],
      }
    );
    const act_5962862420439144_script_9388 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_9388_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_close_9387 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_9388,
        event: "close",
        displayName: "script",
      }
    );
    const act_5962862420439144_showModal_9386 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5962862420439144_showModal_9386_getActionArgs,
        events: [evh_5962862420439144_close_9387],
      }
    );
    const evh_5962862420439144_createProduct_9385 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_showModal_9386,
        event: "createProduct",
        displayName: "showModal",
      }
    );
    const evh_5962862420439144_createProduct = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_createProduct_9385],
      }
    );
    const act_5962862420439144_script_9390 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_9390_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_delete_9389 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_9390,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_5962862420439144_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_delete_9389],
      }
    );
    const act_5962862420439144_script_9392 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_9392_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_productSelected_9391 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_9392,
        event: "product:selected",
        displayName: "script",
      }
    );
    const evh_5962862420439144_productSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_productSelected_9391],
      }
    );
    const act_5962862420439144_script_9394 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_9394_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_quantityChange_9393 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_9394,
        event: "quantity:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_quantityChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_quantityChange_9393],
      }
    );
    const act_5962862420439144_script_9396 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_9396_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_priceChange_9395 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_9396,
        event: "price:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_priceChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_priceChange_9395],
      }
    );
    const act_5962862420439144_script_9398 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_9398_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_discountChange_9397 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_9398,
        event: "discount:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_discountChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_discountChange_9397],
      }
    );
    const act_5962862420439144_script_9400 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_9400_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_netAmountChange_9399 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_9400,
        event: "net_amount:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_netAmountChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_netAmountChange_9399],
      }
    );
    const act_5962862420439144_script_9402 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_9402_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_amountChange_9401 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_9402,
        event: "amount:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_amountChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_amountChange_9401],
      }
    );
    const act_5962862420439144_script_9404 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_9404_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_taxCodeChange_9403 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_9404,
        event: "tax_code:change",
        displayName: "script",
      }
    );
    const evh_5962862420439144_taxCodeChange = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_taxCodeChange_9403],
      }
    );
    const act_5962862420439144_script_9406 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_9406_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_rentalOrPropertySelected_9405 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_9406,
        event: "rental_or_property:selected",
        displayName: "script",
      }
    );
    const evh_5962862420439144_rentalOrPropertySelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_rentalOrPropertySelected_9405],
      }
    );
    const act_5962862420439144_setData_9408 = new actions.SetDataAction(
      {
        actionArgs: this.act_5962862420439144_setData_9408_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_selectedRowsChanged_9407 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_setData_9408,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_5962862420439144_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_selectedRowsChanged_9407],
      }
    );
    const act_7789867021953041_emit_9410 = new actions.EmitAction(
      {
        actionArgs: this.act_7789867021953041_emit_9410_getActionArgs,
        events: [],
      }
    );
    const evh_7789867021953041_reload_9409 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_emit_9410,
        event: "reload",
        displayName: "emit",
      }
    );
    const evh_7789867021953041_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7789867021953041_reload_9409],
      }
    );
    const act_309515315410323_emit_9414 = new actions.EmitAction(
      {
        actionArgs: this.act_309515315410323_emit_9414_getActionArgs,
        events: [],
      }
    );
    const evh_309515315410323_close_9413 = new actions.EventHandlerImpl(
      {
        action: act_309515315410323_emit_9414,
        event: "close",
        when: this.evh_309515315410323_close_9413_getWhen,
        displayName: "emit",
      }
    );
    const act_309515315410323_showModal_9412 = new actions.ShowModalAction(
      {
        actionArgs: this.act_309515315410323_showModal_9412_getActionArgs,
        events: [evh_309515315410323_close_9413],
      }
    );
    const evh_309515315410323_clickPreventStop_9411 = new actions.EventHandlerImpl(
      {
        action: act_309515315410323_showModal_9412,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_309515315410323_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_309515315410323_clickPreventStop_9411],
      }
    );
    const act_880971572885910_script_9418 = new actions.ScriptAction(
      {
        actionArgs: this.act_880971572885910_script_9418_getActionArgs,
        events: [],
      }
    );
    const evh_880971572885910_close_9417 = new actions.EventHandlerImpl(
      {
        action: act_880971572885910_script_9418,
        event: "close",
        when: this.evh_880971572885910_close_9417_getWhen,
        displayName: "script",
      }
    );
    const act_880971572885910_showModal_9416 = new actions.ShowModalAction(
      {
        actionArgs: this.act_880971572885910_showModal_9416_getActionArgs,
        events: [evh_880971572885910_close_9417],
      }
    );
    const evh_880971572885910_clickPreventStop_9415 = new actions.EventHandlerImpl(
      {
        action: act_880971572885910_showModal_9416,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_880971572885910_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_880971572885910_clickPreventStop_9415],
      }
    );
    const act_1803307708030275_script_9420 = new actions.ScriptAction(
      {
        actionArgs: this.act_1803307708030275_script_9420_getActionArgs,
        events: [],
      }
    );
    const evh_1803307708030275_save_9419 = new actions.EventHandlerImpl(
      {
        action: act_1803307708030275_script_9420,
        event: "save",
        displayName: "script",
      }
    );
    const evh_1803307708030275_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_1803307708030275_save_9419],
      }
    );
    const act_1803307708030275_emit_9422 = new actions.EmitAction(
      {
        actionArgs: this.act_1803307708030275_emit_9422_getActionArgs,
        events: [],
      }
    );
    const evh_1803307708030275_saveCompleted_9421 = new actions.EventHandlerImpl(
      {
        action: act_1803307708030275_emit_9422,
        event: "save-completed",
        displayName: "emit",
      }
    );
    const evh_1803307708030275_saveCompleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_1803307708030275_saveCompleted_9421],
      }
    );
    const act_1803307708030275_script_9424 = new actions.ScriptAction(
      {
        actionArgs: this.act_1803307708030275_script_9424_getActionArgs,
        events: [],
      }
    );
    const evh_1803307708030275_delete_9423 = new actions.EventHandlerImpl(
      {
        action: act_1803307708030275_script_9424,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_1803307708030275_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_1803307708030275_delete_9423],
      }
    );
    const act_1803307708030275_emit_9426 = new actions.EmitAction(
      {
        actionArgs: this.act_1803307708030275_emit_9426_getActionArgs,
        events: [],
      }
    );
    const evh_1803307708030275_deleteCompleted_9425 = new actions.EventHandlerImpl(
      {
        action: act_1803307708030275_emit_9426,
        event: "delete-completed",
        displayName: "emit",
      }
    );
    const evh_1803307708030275_deleteCompleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_1803307708030275_deleteCompleted_9425],
      }
    );
    const act_7700024326226090_script_9428 = new actions.ScriptAction(
      {
        actionArgs: this.act_7700024326226090_script_9428_getActionArgs,
        events: [],
      }
    );
    const evh_7700024326226090_save_9427 = new actions.EventHandlerImpl(
      {
        action: act_7700024326226090_script_9428,
        event: "save",
        displayName: "script",
      }
    );
    const evh_7700024326226090_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_7700024326226090_save_9427],
      }
    );
    const act_7700024326226090_script_9430 = new actions.ScriptAction(
      {
        actionArgs: this.act_7700024326226090_script_9430_getActionArgs,
        events: [],
      }
    );
    const evh_7700024326226090_delete_9429 = new actions.EventHandlerImpl(
      {
        action: act_7700024326226090_script_9430,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_7700024326226090_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_7700024326226090_delete_9429],
      }
    );
    const act_7700024326226090_emit_9432 = new actions.EmitAction(
      {
        actionArgs: this.act_7700024326226090_emit_9432_getActionArgs,
        events: [],
      }
    );
    const evh_7700024326226090_saveCompleted_9431 = new actions.EventHandlerImpl(
      {
        action: act_7700024326226090_emit_9432,
        event: "save-completed",
        displayName: "emit",
      }
    );
    const evh_7700024326226090_saveCompleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_7700024326226090_saveCompleted_9431],
      }
    );
    const act_7700024326226090_emit_9434 = new actions.EmitAction(
      {
        actionArgs: this.act_7700024326226090_emit_9434_getActionArgs,
        events: [],
      }
    );
    const evh_7700024326226090_deleteCompleted_9433 = new actions.EventHandlerImpl(
      {
        action: act_7700024326226090_emit_9434,
        event: "delete-completed",
        displayName: "emit",
      }
    );
    const evh_7700024326226090_deleteCompleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_7700024326226090_deleteCompleted_9433],
      }
    );
    return {
      act_1889980785424776_showModal_9376,
      evh_1889980785424776_clickPreventStop_9375,
      evh_1889980785424776_clickPreventStop,
      act_4892266742011185_emit_9380,
      evh_4892266742011185_success_9379,
      act_4892266742011185_request_9378,
      evh_4892266742011185_clickPreventStop_9377,
      evh_4892266742011185_clickPreventStop,
      act_5962862420439144_emit_9382,
      evh_5962862420439144_saveCompleted_9381,
      evh_5962862420439144_saveCompleted,
      act_5962862420439144_script_9384,
      evh_5962862420439144_save_9383,
      evh_5962862420439144_save,
      act_5962862420439144_script_9388,
      evh_5962862420439144_close_9387,
      act_5962862420439144_showModal_9386,
      evh_5962862420439144_createProduct_9385,
      evh_5962862420439144_createProduct,
      act_5962862420439144_script_9390,
      evh_5962862420439144_delete_9389,
      evh_5962862420439144_delete,
      act_5962862420439144_script_9392,
      evh_5962862420439144_productSelected_9391,
      evh_5962862420439144_productSelected,
      act_5962862420439144_script_9394,
      evh_5962862420439144_quantityChange_9393,
      evh_5962862420439144_quantityChange,
      act_5962862420439144_script_9396,
      evh_5962862420439144_priceChange_9395,
      evh_5962862420439144_priceChange,
      act_5962862420439144_script_9398,
      evh_5962862420439144_discountChange_9397,
      evh_5962862420439144_discountChange,
      act_5962862420439144_script_9400,
      evh_5962862420439144_netAmountChange_9399,
      evh_5962862420439144_netAmountChange,
      act_5962862420439144_script_9402,
      evh_5962862420439144_amountChange_9401,
      evh_5962862420439144_amountChange,
      act_5962862420439144_script_9404,
      evh_5962862420439144_taxCodeChange_9403,
      evh_5962862420439144_taxCodeChange,
      act_5962862420439144_script_9406,
      evh_5962862420439144_rentalOrPropertySelected_9405,
      evh_5962862420439144_rentalOrPropertySelected,
      act_5962862420439144_setData_9408,
      evh_5962862420439144_selectedRowsChanged_9407,
      evh_5962862420439144_selectedRowsChanged,
      act_7789867021953041_emit_9410,
      evh_7789867021953041_reload_9409,
      evh_7789867021953041_reload,
      act_309515315410323_emit_9414,
      evh_309515315410323_close_9413,
      act_309515315410323_showModal_9412,
      evh_309515315410323_clickPreventStop_9411,
      evh_309515315410323_clickPreventStop,
      act_880971572885910_script_9418,
      evh_880971572885910_close_9417,
      act_880971572885910_showModal_9416,
      evh_880971572885910_clickPreventStop_9415,
      evh_880971572885910_clickPreventStop,
      act_1803307708030275_script_9420,
      evh_1803307708030275_save_9419,
      evh_1803307708030275_save,
      act_1803307708030275_emit_9422,
      evh_1803307708030275_saveCompleted_9421,
      evh_1803307708030275_saveCompleted,
      act_1803307708030275_script_9424,
      evh_1803307708030275_delete_9423,
      evh_1803307708030275_delete,
      act_1803307708030275_emit_9426,
      evh_1803307708030275_deleteCompleted_9425,
      evh_1803307708030275_deleteCompleted,
      act_7700024326226090_script_9428,
      evh_7700024326226090_save_9427,
      evh_7700024326226090_save,
      act_7700024326226090_script_9430,
      evh_7700024326226090_delete_9429,
      evh_7700024326226090_delete,
      act_7700024326226090_emit_9432,
      evh_7700024326226090_saveCompleted_9431,
      evh_7700024326226090_saveCompleted,
      act_7700024326226090_emit_9434,
      evh_7700024326226090_deleteCompleted_9433,
      evh_7700024326226090_deleteCompleted,
      deleteSelectedLines: act_4892266742011185_request_9378,
    }
  }
}

Vue.component("UcInvoiceLines", UcInvoiceLines);

</script>